export const APP_MODULES = {
  CAMPAIGN_FINANCES: 'CAMPAIGN_FINANCES',
  BULK_TASKS: 'BULK_TASKS',
};
